import { render, staticRenderFns } from "./teachingPlan.vue?vue&type=template&id=6ecfa81b&scoped=true&"
import script from "./teachingPlan.vue?vue&type=script&lang=js&"
export * from "./teachingPlan.vue?vue&type=script&lang=js&"
import style0 from "./teachingPlan.vue?vue&type=style&index=0&id=6ecfa81b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecfa81b",
  null
  
)

export default component.exports